import { OnInit, EventEmitter, AfterContentInit, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TimeSlot, TimeSlotType } from 'src/app/shared/models/time-slot.model';
import { DateHelper } from 'src/app/shared/utils/date-helper';
import { StringHelper } from 'src/app/shared/utils/string-helper';
import { ArrayHelper } from 'src/app/shared/utils/array-helper';
import { LanguageService } from 'src/app/shared/services/language.service';
import { RoomPublicService } from 'src/app/shared/services/rest/room-public.service';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DevicePublicService } from 'src/app/shared/services/rest/device-public.service';
import { ResourceType } from 'src/app/shared/models/resource-type';
import { v4 as id4 } from 'uuid';
var CreateReservationDateComponent = /** @class */ (function () {
    function CreateReservationDateComponent(language, roomPublicService, devicePublicService, translate) {
        this.language = language;
        this.roomPublicService = roomPublicService;
        this.devicePublicService = devicePublicService;
        this.translate = translate;
        this.subscriptions = [];
        this.hourMultiplicator = 4;
        this.dataLoader = null;
        this.supressErrorMessageNotice = false;
        /**
         * delete event
         *
         * @type {EventEmitter<number>}
         * @memberof CreateReservationDateComponent
         */
        this.delete = new EventEmitter();
        /**
         * restore date event (undo changes)
         *
         * @type {EventEmitter<number>}
         * @memberof CreateReservationDateComponent
         */
        this.restore = new EventEmitter();
        /**
         * save event
         *
         * @type {EventEmitter<number>}
         * @memberof CreateReservationDateComponent
         */
        this.save = new EventEmitter();
        /**
         * signal occupied time window
         * @memberof CreateReservationDateComponent
         */
        this.reservationConflict = new EventEmitter();
        /**
         * Signals when a conflict has been resolved or component on destroy
         */
        this.conflictResolved = new EventEmitter();
        /**
         * Signals if date is reservable
         * @memberof CreateReservationDateComponent
         */
        this.dateNotReservable = new EventEmitter();
        /**
         * Time from dropdown selectables
         *
         * @type {IMultiDropdownData[]}
         * @memberof CreateReservationDateComponent
         */
        this.selectTimeFromValues = [];
        /**
         * Time to dropdown selectables
         *
         * @type {IMultiDropdownData[]}
         * @memberof CreateReservationDateComponent
         */
        this.selectTimeToValues = [];
    }
    Object.defineProperty(CreateReservationDateComponent.prototype, "isNew", {
        // state props
        get: function () {
            if (!this.formId) {
                return true;
            }
            return !this.isSaved && (!this.formId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationDateComponent.prototype, "isReadonly", {
        get: function () {
            return this.formGroup.get(nameof('date')).disabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationDateComponent.prototype, "displaySaveButton", {
        // display props
        get: function () {
            return !this.isNewReservation && !this.isNew;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationDateComponent.prototype, "enableSaveButton", {
        get: function () {
            return this.formGroup.valid && (this.formGroup.dirty || this.isNew);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationDateComponent.prototype, "displayCancelButton", {
        get: function () {
            return !this.isReadonly && (this.formGroup.dirty || this.isNew);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationDateComponent.prototype, "displayDeleteButton", {
        get: function () {
            return !this.isNew;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationDateComponent.prototype, "enableDeleteButton", {
        get: function () {
            return !this.isReadonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationDateComponent.prototype, "displayIndicatorOk", {
        get: function () {
            // todo: remove function
            return false; // !this.isReadonly && this.formGroup.valid && !this.hasError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationDateComponent.prototype, "displayIndicatorError", {
        get: function () {
            return !this.isReadonly && this.hasError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationDateComponent.prototype, "formId", {
        // other props
        get: function () {
            return Number(this.formGroup.get(nameof('id')).value);
        },
        set: function (value) {
            this.formGroup.get(nameof('id')).patchValue(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationDateComponent.prototype, "formDate", {
        get: function () {
            return DateHelper.parseIsoDateString(this.formGroup.get(nameof('date')).value);
        },
        set: function (value) {
            this.formGroup.get(nameof('date')).patchValue(value.toISOString());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationDateComponent.prototype, "formFrom", {
        get: function () {
            return Number(this.formGroup.get(nameof('dateTimeFrom')).value);
        },
        set: function (value) {
            this.formGroup.get(nameof('dateTimeFrom')).setValue(String(value));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationDateComponent.prototype, "formTo", {
        get: function () {
            return Number(this.formGroup.get(nameof('dateTimeTo')).value);
        },
        set: function (value) {
            this.formGroup.get(nameof('dateTimeTo')).setValue(String(value));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateReservationDateComponent.prototype, "formMessage", {
        get: function () {
            return this.formGroup.get(nameof('message')).value;
        },
        set: function (value) {
            this.formGroup.get(nameof('message')).setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
    * Create a new formGroup model
    *
    * @static
    * @returns {IReservationDateForm}
    * @memberof CreateReservationDateComponent
    */
    CreateReservationDateComponent.createFormGroupModel = function (formBuilder) {
        var model = {
            id: 0,
            date: new FormControl('', [
                Validators.required
            ]),
            dateTimeFrom: new FormControl('', [
                Validators.required
            ]),
            dateTimeTo: new FormControl('', [
                Validators.required
            ]),
            message: new FormControl(''),
        };
        var fg = formBuilder.group(model);
        return fg;
    };
    CreateReservationDateComponent.prototype.ngOnChanges = function (changes) {
        if ('resourceOccupancies' in changes || 'timeSlots' in changes) {
            if (!this.resourceOccupancies || !this.timeSlots) {
                this.conflictReport = null;
                if (this.uuid) {
                    this.conflictResolved.emit(this.uuid);
                }
            }
            else {
                this.onStartTimeChange(this.formGroup.value.dateTimeFrom);
                this.onEndTimeChange(this.formGroup.value.dateTimeTo);
            }
        }
    };
    CreateReservationDateComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.isNewReservation === undefined) {
            throw Error(nameof('isNewReservation') + ' must be set on CreateReservationDateComponent');
        }
        // get a unique id
        this.uuid = id4();
        if (typeof this.dataLoader === 'function') {
            var formDateTimestamp = this.formDate.getTime();
            var from = new Date(formDateTimestamp + this.formFrom);
            var to = new Date(formDateTimestamp + this.formTo);
            this.dataLoader(from, to).then(function (data) {
                _this.resourceOccupancies = data;
            })
                .then(function () {
                _this.onStartTimeChange(_this.formGroup.value.dateTimeFrom);
                _this.onEndTimeChange(_this.formGroup.value.dateTimeTo);
            })
                .catch(function (er) {
                console.error('Failed to load resource occupancies', er);
            });
        }
        else if (this.dataLoader) {
            throw new Error('Invalid data loader specified');
        }
        this.language.getDateFormat().then(function (val) {
            _this.dateFormat = val;
        });
        switch (this.type) {
            case ResourceType.Raum:
                this.resourcePublicService = this.roomPublicService;
                break;
            case ResourceType.Gerät:
                this.resourcePublicService = this.devicePublicService;
                break;
            default:
                throw Error(nameof('type') + ' must be set on CreateReservationDateComponent');
        }
    };
    CreateReservationDateComponent.prototype.ngAfterContentInit = function () {
        this.initForm();
    };
    CreateReservationDateComponent.prototype.loadTimeSlots = function (date) {
        var _this = this;
        if (this.idRessource === 0 || !(date instanceof Date)) {
            return;
        }
        this.currentTimeslotDate = date;
        return this.resourcePublicService.getTimeSlots(this.idRessource, DateHelper.getUnixTime(new Date(date.getFullYear(), date.getMonth(), date.getDate())), DateHelper.getUnixTime(new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999))).pipe(tap(function (x) {
            _this.timeSlots = x.map(function (o) { return TimeSlot.create(o); }).sortByProp(function (r) { return r.StartMinuteIndex; });
            _this.selectTimeFromValues = _this.getFromDropdownData(_this.timeSlots);
            if (!_this.formFrom) {
                _this.formFrom = Number(_this.selectTimeFromValues[0].key);
            }
            _this.enableDisableDropdowns();
        }), catchError(function (err) {
            _this.currentTimeslotDate = null;
            return throwError(err);
        })).toPromise();
    };
    CreateReservationDateComponent.prototype.ngOnDestroy = function () {
        this.conflictResolved.emit(this.uuid);
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /**
     * Set enabled/disbled state and error message for timeslots
     *
     * @private
     * @memberof CreateReservationDateComponent
     */
    CreateReservationDateComponent.prototype.enableDisableDropdowns = function () {
        var _this = this;
        if (this.timeSlots.length === 0) {
            var sub = this.translate.get('ROOM_STATE_NO_WORKDAY', { date: this.language.formatDate(this.formDate) }).subscribe(function (value) {
                _this.formMessage = value;
                _this.dateNotReservable.emit([_this.index, _this.formGroup]);
            });
            this.queueUnsubscribe(sub);
        }
        if (this.timeSlots.length === 0 || this.isReadonly) {
            this.formGroup.get(nameof('dateTimeFrom')).disable();
            this.formGroup.get(nameof('dateTimeTo')).disable();
        }
        else {
            this.formGroup.get(nameof('dateTimeFrom')).enable();
            this.formGroup.get(nameof('dateTimeTo')).enable();
        }
        this.formGroup.updateValueAndValidity();
    };
    CreateReservationDateComponent.prototype.queueUnsubscribe = function (sub) {
        if (this.subscriptions.includes(sub)) {
            return;
        }
        // ? maybe use a set here
        this.subscriptions.push(sub);
    };
    CreateReservationDateComponent.prototype.presentConflictMessage = function (shouldPresent) {
        var _this = this;
        if (shouldPresent === true) {
            var sub = this.translate.get('ROOM_TIMELINE_OCCUPIED', { date: this.language.formatDate(this.formDate) }).subscribe(function (value) {
                _this.formMessage = value;
            });
            this.queueUnsubscribe(sub);
        }
        else {
            this.formMessage = null;
        }
    };
    /**
     * handle save click
     *
     * @memberof CreateReservationDateComponent
     */
    CreateReservationDateComponent.prototype.onSaveClick = function () {
        if (!this.isReadonly && this.enableSaveButton) {
            this.save.emit(this.index);
        }
    };
    /**
     * handle delete click
     *
     * @memberof CreateReservationDateComponent
     */
    CreateReservationDateComponent.prototype.onDeleteClick = function () {
        if (!this.isReadonly) {
            this.delete.emit(this.index);
        }
    };
    /**
     * remove unsafed item
     *
     * @memberof CreateReservationDateComponent
     */
    CreateReservationDateComponent.prototype.onCancelClick = function () {
        if (!this.isReadonly) {
            if (this.isNew) {
                this.delete.emit(this.index);
            }
            else {
                this.restore.emit(this.index);
            }
        }
    };
    /**
     * Initialize the form
     *
     * @private
     * @memberof CreateReservationDateComponent
     */
    CreateReservationDateComponent.prototype.initForm = function () {
        var _this = this;
        // preset values
        var date = this.formDate;
        if (date !== undefined && date instanceof Date) {
            var startMinutes_1 = this.formFrom;
            this.loadTimeSlots(date)
                .then(function (_) {
                _this.updateToDropdownData(Number(startMinutes_1));
                _this.attachFormEvents();
            });
        }
        else {
            this.attachFormEvents();
        }
    };
    CreateReservationDateComponent.prototype.onDateChange = function (newValue) {
        var date = DateHelper.parseIsoDateString(newValue);
        if (!this.currentTimeslotDate || date.toDateString() !== this.currentTimeslotDate.toDateString()) {
            this.formMessage = '';
            this.loadTimeSlots(date);
            this.dateNotReservable.emit(null);
        }
    };
    CreateReservationDateComponent.prototype.groupByContinuosBlocks = function (blocks) {
        var groups = blocks.reduce(function (grps, block, i, all) {
            if (grps === null) {
                return [[block]];
            }
            var last = grps.pop();
            grps.push(last);
            var lastTimeSlot = last.slice(-1)[0];
            if (lastTimeSlot.EndMinuteIndex + 1 === block.StartMinuteIndex) {
                last.push(block);
            }
            else {
                grps.push([block]);
            }
            return grps;
        }, null);
        return groups;
    };
    CreateReservationDateComponent.prototype.onStartTimeChange = function (startMinutes) {
        var _this = this;
        var $this = this;
        var newStartMinuteCount = Number(startMinutes);
        var currentEndMinuteCount = Number($this.formGroup.value.dateTimeTo);
        var withinFreeSlot = -1 !== $this.resourceOccupancies.findIndex(function (ts) { return ts.SlotType === TimeSlotType.Vacant
            && ts.StartMinuteIndex <= newStartMinuteCount
            && ts.EndMinuteIndex >= currentEndMinuteCount - 1; });
        // this logic is for handling conflict error for existing reservations
        if (withinFreeSlot !== true && this.formId && $this.resourceOccupancies.findIndex(function (roc) { return Number(roc.IdObject) === _this.formId; }) !== -1) {
            var selTS = $this.resourceOccupancies.filter(function (roc) { return roc.SlotType === TimeSlotType.Vacant || Number(roc.IdObject) === _this.formId; });
            var conblocks = this.groupByContinuosBlocks(selTS);
            withinFreeSlot = -1 !== conblocks.findIndex(function (tsb) { return tsb[0].StartMinuteIndex <= newStartMinuteCount
                && tsb.slice(-1)[0].EndMinuteIndex >= currentEndMinuteCount - 1; });
        }
        if (withinFreeSlot === false) {
            var timeSlotBlocks = $this.resourceOccupancies.filter(function (ts) { return ts.SlotType !== TimeSlotType.Vacant
                && ts.EndMinuteIndex > newStartMinuteCount
                && ts.StartMinuteIndex < currentEndMinuteCount; });
            var blockedSlots = timeSlotBlocks.filter(function (ts) { return ts.SlotType !== TimeSlotType.Vacant; });
            var firstSlot = blockedSlots[0];
            var lastSlot = blockedSlots[blockedSlots.length - 1];
            $this.presentConflictMessage(true);
            $this.conflictReport = {
                timeFrom: DateHelper.setTimeFromMinutesOfDay(newStartMinuteCount, new Date(firstSlot.DateTimeFrom)),
                timeTo: DateHelper.setTimeFromMinutesOfDay(currentEndMinuteCount, new Date(lastSlot.DateTimeFrom)),
                occupancies: blockedSlots.sortByProp(function (p) { return p.StartMinuteIndex; }),
                senderId: this.uuid
            };
            $this.reservationConflict.emit(Object.assign({}, $this.conflictReport));
        }
        else {
            // clear validation notice
            $this.presentConflictMessage(false);
            $this.conflictReport = null;
            $this.conflictResolved.emit(this.uuid);
        }
        if (startMinutes !== '') {
            $this.updateToDropdownData(Number(startMinutes));
        }
    };
    CreateReservationDateComponent.prototype.onEndTimeChange = function (endMinuteIndex) {
        var _this = this;
        var $this = this;
        var newEndMinuteIndex = Number(endMinuteIndex) - 1;
        var currentStartMinuteIndex = Number($this.formGroup.value.dateTimeFrom);
        var withinFreeSlot = -1 !== $this.resourceOccupancies.findIndex(function (ts) { return ts.SlotType === TimeSlotType.Vacant
            && ts.StartMinuteIndex <= currentStartMinuteIndex
            && ts.EndMinuteIndex >= newEndMinuteIndex - 1; });
        // this logic is for handling conflict error for existing reservations
        if (withinFreeSlot !== true && this.formId && $this.resourceOccupancies.findIndex(function (roc) { return Number(roc.IdObject) === _this.formId; }) !== -1) {
            var selTS = $this.resourceOccupancies.filter(function (roc) { return roc.SlotType === TimeSlotType.Vacant || Number(roc.IdObject) === _this.formId; });
            var conblocks = this.groupByContinuosBlocks(selTS);
            withinFreeSlot = -1 !== conblocks.findIndex(function (tsb) { return tsb[0].StartMinuteIndex <= currentStartMinuteIndex
                && tsb.slice(-1)[0].EndMinuteIndex >= newEndMinuteIndex - 1; });
        }
        if (withinFreeSlot === false) {
            var timeSlotBlocks = $this.resourceOccupancies.filter(function (ts) { return ts.SlotType !== TimeSlotType.Vacant
                && ts.EndMinuteIndex > currentStartMinuteIndex
                && ts.StartMinuteIndex < newEndMinuteIndex; });
            var blockedSlots = timeSlotBlocks.filter(function (ts) { return ts.SlotType !== TimeSlotType.Vacant; });
            var firstSlot = blockedSlots[0];
            var lastSlot = blockedSlots[blockedSlots.length - 1];
            $this.presentConflictMessage(true);
            $this.conflictReport = {
                timeFrom: DateHelper.setTimeFromMinutesOfDay(currentStartMinuteIndex, new Date(firstSlot.DateTimeFrom)),
                timeTo: DateHelper.setTimeFromMinutesOfDay(newEndMinuteIndex, new Date(lastSlot.DateTimeFrom)),
                occupancies: blockedSlots.sortByProp(function (p) { return p.StartMinuteIndex; }),
                senderId: this.uuid
            };
            $this.reservationConflict.emit(Object.assign({}, $this.conflictReport));
        }
        else {
            // clear validation notice
            $this.presentConflictMessage(false);
            $this.conflictReport = null;
            $this.conflictResolved.emit(this.uuid);
        }
    };
    /**
     * attach listening for form-changes
     *
     * @private
     * @memberof CreateReservationDateComponent
     */
    CreateReservationDateComponent.prototype.attachFormEvents = function () {
        var _this = this;
        if (this.formGroup.disabled) {
            return;
        }
        var sub = this.formGroup.get(nameof('date')).valueChanges.subscribe(function (value) {
            _this.onDateChange(value);
        });
        this.queueUnsubscribe(sub);
        this.formGroup.get(nameof('dateTimeFrom')).valueChanges.forEach(function (startMinutesIndex) {
            _this.onStartTimeChange(startMinutesIndex);
        });
        this.formGroup.get(nameof('dateTimeTo')).valueChanges.forEach(function (endMinuteIndex) {
            _this.onEndTimeChange(endMinuteIndex);
        });
    };
    /**
     * Get 'from' dropdown values
     *
     * @private
     * @param {TimeSlot[]} timeSlots
     * @returns {IMultiDropdownData[]}
     * @memberof CreateReservationDialogComponent
     */
    CreateReservationDateComponent.prototype.getFromDropdownData = function (timeSlots) {
        var multiplicator = this.hourMultiplicator;
        var increment = 60 / multiplicator;
        var result = new Array();
        timeSlots.forEach(function (ts) {
            var startMinutes = DateHelper.getMinutesOfDay(ts.DateTimeFrom);
            var endMinutes = DateHelper.getMinutesOfDay(ts.DateTimeTo);
            // start on room open, even if time is not within interval (eg. 6:55 is not in 15 min interval)
            var alignedStart = (startMinutes % 60) % increment === 0
                ? startMinutes
                : Math.ceil(startMinutes / 60 * multiplicator) / multiplicator * 60;
            if (startMinutes !== alignedStart) {
                result.push({ key: String(startMinutes), text: StringHelper.formatTimeMinutes(startMinutes), selected: false });
            }
            for (var i = alignedStart; i < endMinutes; i += increment) {
                result.push({ key: String(i), text: StringHelper.formatTimeMinutes(i), selected: false });
            }
        });
        return result;
    };
    /**
     * Update 'to' dropdown values
     *
     * @private
     * @param {number} startMinutes
     * @memberof CreateReservationDialogComponent
     */
    CreateReservationDateComponent.prototype.updateToDropdownData = function (startMinutes) {
        // preserve initial/previous timespan
        var oldStart = Number(this.formGroup.value.dateTimeFrom);
        var diff = Number(this.formGroup.value.dateTimeTo) - oldStart;
        var endPreset = diff > 0 ? startMinutes + diff : startMinutes + 60;
        var selectedSlot = this.timeSlots
            .find(function (ts) { return ts.StartMinuteIndex <= startMinutes && ts.EndMinuteIndex > startMinutes; });
        var endMinutes = selectedSlot === undefined
            ? (Array.isArray(this.resourceOccupancies) && this.resourceOccupancies.length > 0
                ? this.resourceOccupancies.reverse().find(function (oc) { return oc && oc.SlotType !== TimeSlotType.Vacant; }).StartMinuteIndex - 1
                : 0)
            : selectedSlot.EndMinuteIndex;
        var result = new Array();
        if (selectedSlot !== undefined) {
            var increment = 60 / this.hourMultiplicator;
            for (var i = startMinutes + increment; i < endMinutes; i += increment) {
                result.push({ key: String(i), text: StringHelper.formatTimeMinutes(i), selected: i === endPreset });
            }
            result.push({ key: String(endMinutes), text: StringHelper.formatTimeMinutes(endMinutes), selected: endMinutes === endPreset });
        }
        this.selectTimeToValues = result;
        var selectedItems = this.selectTimeToValues.filter(function (x) { return x.selected; });
        if (ArrayHelper.hasAny(selectedItems) && Number(selectedItems[0].key) !== this.formTo) {
            this.formTo = Number(selectedItems[0].key);
        }
        else if (endPreset > this.formTo) {
            // TODO: clear up if time should be rounded to 5min and when timespan exceeds last possible time choice
            // does not match any dropdown entry, but set directly since free input is allowed
            // limit to last minute index of current day
            this.formTo = Math.min(endPreset, 24 * 60 - 1);
        }
    };
    // wrapper for service class caller
    CreateReservationDateComponent.prototype.getCHTimeString = function (time) {
        return DateHelper.getCHTimeString(time);
    };
    return CreateReservationDateComponent;
}());
export { CreateReservationDateComponent };
